<template>
  <v-app>
    <template v-if="!loading">
      <Header />
      <v-main>
        <router-view />
      </v-main>
      <Footer />
    </template>
    <Loading v-else />
    <CookieBanner></CookieBanner>
  </v-app>
</template>

<script>
import Header from "@/components/shell/header/Index.vue";
import Footer from "@/components/shell/Footer.vue";
import CookieBanner from "@/components/widgets/CookieBanner.vue";
import Loading from "@/components/widgets/Loading.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = !this.name
        ? this.$route.name
        : `${this.$route.name} - ${this.name}`;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();

      this.$rest("banners").get();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  beforeCreate() {
    this.$rest("informations")
      .get({ save: (state, data) => (state.item = data) })
      .then(() => (this.loading = false));

    this.$rest("articles-categories").get();

    this.$rest("banners").get();

    this.$rest("about").get({ save: (state, data) => (state.item = data) });
  },
  created() {
    this.updateDocumentTitle();
  },
  components: {
    Header,
    Footer,
    CookieBanner,
    Loading,
  },
};
</script>

<style>
.roboto-condensed {
  font-family: "Roboto Condensed", sans-serif;
}

@media screen and (min-width: 1200px) {
  .container {
    max-width: 1194px !important;
  }
}

.filter-white {
  filter: brightness(0) invert(1);
}
</style>
